<template>
  <div class="code-bg" style="width: 100%; height: 100vh">
    <div>
      <!-- <ve-map
        ref="emap"
        :data="chartData"
        height="800px"
        :legend-visible="false"
        :settings="chartSettings"
        :events="chartEvents"
        :visual-map="chartVisualMap"
        :tooltip="tooltip"
      ></ve-map>-->
      <el-row :gutter="20">
        <el-col :span="18">
          <div style="border: 2px solid rgba(0, 135, 255, 0.6)">
            <ve-map
              height="90vh"
              :data="chartData"
              :legend-visible="false"
              :settings="chartSettings"
              :visual-map="chartVisualMap"
              :events="chartEvents"
            ></ve-map>
          </div>
        </el-col>
        <el-col :span="6">
          <div style="height: 90vh; border: 2px solid rgba(0, 135, 255, 0.6)">
            <ve-bar
              height="90vh"
              width="98%"
              :data="barChartData"
              :settings="barChartSettings"
              :extend="barChartExtend"
              :colors="barColors"
              :textStyle="barTextStyle"
            ></ve-bar>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="margin-top: 20px">
      <el-row :gutter="15">
        <el-col :span="2">
          <el-button v-if="provinceFlag" type="primary" @click="reset()"
            >返回上级</el-button
          >
        </el-col>
        <el-col :span="4">
          <el-input v-model="query.gtin" placeholder="请输入商品编号">
            <template slot="prepend">商品编号</template>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input v-model="query.batchNumber" placeholder="请输入批号">
            <template slot="prepend">批号</template>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            unlink-panels
            value-format="yyyy-MM-dd"
            clearable
          ></el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 15px" type="primary" @click="submit()"
            >统计</el-button
          >
          <el-button style="margin-left: 10px" @click="reset1()"
            >重置</el-button
          >

          <el-button
            style="margin-left: 10px"
            type="warning"
            @click="
              popupVisible = true;
              listQuery.page;
              getList();
            "
            >配置预警</el-button
          >
        </el-col>
        <el-col :span="4">
          <span style="color: #fff">数据获取时间:{{ countTime }}</span>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      title="扫码预警"
      :visible.sync="popupVisible"
      width="60%"
      @closed="
        editId = null;
        hiddenPopover();
      "
      custom-class="daily-box"
    >
      <div
        class="df"
        style="
          background-color: #eee;
          gap: 10px;
          height: 100%;
          flex-direction: column;
        "
      >
        <div
          style="
            padding: 10px 30px;
            background-color: #fff;
            border-radius: 10px;
            overflow: hidden;
            justify-content: flex-end;
            width: 100%;
          "
          class="df aic"
        >
          <el-popover
            placement="bottom"
            width="600"
            trigger="click"
            v-model="showPopover"
            @show="openPopover"
            @hide="hiddenPopover"
          >
            <div style="padding: 20px 20px 0" v-if="showPopover">
              <el-form
                ref="addform"
                :model="scanCodeRecordForm"
                label-width="120px"
                label-position="left"
                :rules="formRules"
              >
                <el-form-item label="预警城市" prop="city">
                  <el-cascader
                    style="width: 100%"
                    :props="cityProps"
                    @change="cityChange"
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="预警商品" prop="gtin">
                  <el-select
                    v-model="goodsName"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入商品名称或商品编码"
                    :remote-method="remoteMethod"
                    :loading="goodsLoading"
                    @change="goodsChange"
                  >
                    <el-option
                      v-for="item in goodsOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <div>
                        <div>{{ item.label }}</div>
                        <div
                          style="float: right; color: #8492a6; font-size: 13px"
                        >
                          {{ item.gtin }}
                        </div>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预警批次" prop="batchNumber">
                  <el-select
                    v-model="batchNumber"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入批次号"
                    :remote-method="remoteMethod1"
                    :loading="goodsLoading"
                    @change="batchChange"
                  >
                    <el-option
                      v-for="item in batchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                      <div>
                        <div>{{ item.label }}</div>
                        <div
                          style="float: right; color: #8492a6; font-size: 13px"
                        >
                          {{ item.gtin }}
                        </div>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="最大扫码次数" prop="maxValue">
                  <el-input
                    placeholder="最大扫码次数"
                    v-model="scanCodeRecordForm.maxValue"
                    type="number"
                    clearable
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="预警通知人" prop="toUserIds">
                  <el-checkbox-group
                    v-model="scanCodeRecordForm.toUserIds"
                    @change="handleCheckedChange"
                    size="mini"
                  >
                    <div class="user-scroll-box">
                      <div class="user-scroll">
                        <el-checkbox
                          v-for="user in userList"
                          :label="user.userId"
                          :key="user.userId"
                          :border="true"
                          ><div>{{ user.userName }}</div></el-checkbox
                        >
                      </div>
                    </div>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item>
                  <div class="df aic jcc">
                    <el-button type="primary" @click="scanCodeSubmit"
                      >提交</el-button
                    >
                    <el-button
                      @click="showPopover = false"
                      style="margin-left: 10px"
                      >取消</el-button
                    >
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <el-button slot="reference" size="small" type="primary"
              >新增预警</el-button
            >
          </el-popover>
        </div>
        <div
          class="df"
          style="
            width: 100%;
            height: 0;
            flex: 1;
            flex-direction: row;
            gap: 10px;
          "
        >
          <div
            style="
              padding: 10px 30px;
              background-color: #fff;
              border-radius: 10px;
              overflow: hidden;
              flex: 1;
              height: 100%;
              width: 0;
            "
          >
            <el-table :data="list" stripe style="width: 100%">
              <el-table-column prop="city" label="预警城市" width="180">
              </el-table-column>
              <el-table-column prop="goodsName" label="预警商品" width="180">
              </el-table-column>
              <el-table-column prop="batchNumber" label="预警批次" width="180">
              </el-table-column>
              <el-table-column prop="maxValue" label="最大扫码次数">
              </el-table-column>
              <el-table-column prop="toUserNames" label="预警通知人员">
                <template slot-scope="scope">
                  <el-tag
                    type="success"
                    style="margin: 5px"
                    v-for="(item, index) in scope.row.toUserNames"
                    :key="index"
                    >{{ item }}</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    slot="reference"
                    type="text"
                    class="disib"
                    size="mini"
                    style="margin-left: 10px"
                    @click="handleEdit(scope.row)"
                    >修改</el-button
                  >
                  <el-button
                    @click="handleDelete(scope.row)"
                    type="text"
                    class="disib"
                    size="mini"
                    style="margin-left: 10px; color: #f56c6c"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            v-if="editId !== null"
            style="
              padding: 10px 30px;
              background-color: #fff;
              border-radius: 10px;
              overflow: hidden;
              flex: 0 0 530px;
              height: 100%;
              width: 0;
            "
          >
            <el-form
              ref="editForm"
              :model="scanCodeRecordForm"
              label-width="120px"
              label-position="left"
              :rules="formRules"
            >
              <el-form-item label="预警城市" prop="city">
                <el-cascader
                  :placeholder="
                    '请选择城市,若不选择则默认为' + scanCodeRecordForm.city
                  "
                  style="width: 100%"
                  :props="cityProps"
                  @change="cityChange"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="预警商品" prop="gtin">
                <el-select
                  v-model="goodsName"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入商品名称或商品编码"
                  :remote-method="remoteMethod"
                  :loading="goodsLoading"
                  @change="goodsChange"
                >
                  <el-option
                    v-for="item in goodsOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <div>
                      <div>{{ item.label }}</div>
                      <div
                        style="float: right; color: #8492a6; font-size: 13px"
                      >
                        {{ item.gtin }}
                      </div>
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="预警批次" prop="batchNumber">
                <el-select
                  v-model="batchNumber"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入批次号"
                  :remote-method="remoteMethod1"
                  :loading="goodsLoading"
                  @change="batchChange"
                >
                  <el-option
                    v-for="item in batchOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <div>
                      <div>{{ item.label }}</div>
                      <div
                        style="float: right; color: #8492a6; font-size: 13px"
                      >
                        {{ item.gtin }}
                      </div>
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="最大扫码次数" prop="maxValue">
                <el-input
                  placeholder="最大扫码次数"
                  v-model="scanCodeRecordForm.maxValue"
                  type="number"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item label="预警通知人" prop="toUserIds">
                <el-checkbox-group
                  v-model="scanCodeRecordForm.toUserIds"
                  @change="handleCheckedChange"
                  size="mini"
                >
                  <div class="user-scroll-box1">
                    <div class="user-scroll1">
                      <el-checkbox
                        v-for="user in userList"
                        :label="user.userId"
                        :key="user.userId"
                        :border="true"
                        ><div>{{ user.userName }}</div></el-checkbox
                      >
                    </div>
                  </div>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item>
                <div class="df aic jcc">
                  <el-button type="primary" @click="handleUpdate"
                    >修改</el-button
                  >
                  <el-button @click="editId = null" style="margin-left: 10px"
                    >取消</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div
          style="
            padding: 10px 30px;
            background-color: #fff;
            border-radius: 10px;
            overflow: hidden;
            justify-content: flex-end;
            width: 100%;
          "
          class="df aic"
        >
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.page"
            :page-size="listQuery.limit"
            layout="total, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mapBg from "@/assets/image/mapbg.png";
import provinces from "./provinces.json";
import transformation from "./transformation.json";
import "echarts/lib/component/visualMap";
import api from "../../../util/extra-api";
import { formatTime } from "../../../util/util";
import axios from "@/util/api";

export default {
  components: {},
  data() {
    this.chartVisualMap = {
      min: 0,
      max: 1,
      show: true,
      left: "left",
      top: "bottom",
      text: ["High", "Low"],
      seriesIndex: [0],
      textStyle: {
        color: "#fff",
      },
      inRange: {
        color: ["#FFC809", "#F46E36"],
      },
      calculable: true,
    };
    this.chartEvents = {
      mapselectchanged: (v) => {
        const provinceName = this.provincesData[v.batch[0].name];
        if (provinceName) {
          this.chartSettings.position = `province/${provinceName}`;
          this.getDataCity(v.batch[0].name);
          this.provinceFlag = true;
        }
      },
    };
    this.barChartSettings = {
      labelMap: {
        total: "统计值",
      },
      itemStyle: {
        normal: {
          label: {
            show: true, //开启显示
            position: "right", //在上方显示
            textStyle: {
              //数值样式
              color: "#fff",
              fontSize: 16,
            },
          },
        },
      },
    };
    // this.barLegend = {
    //   textStyle:{
    //     color:'#fff'
    //   }
    // }
    this.barTextStyle = {
      color: "#fff",
      fontSize: 13,
    };
    this.barChartExtend = {
      series: {
        type: "bar",
        barMaxWidth: "30",
      },
      legend: {
        textStyle: {
          color: "#fff",
        },
      },
      xAxis: {
        minInterval: 1,
      },
    };
    this.barColors = ["#04B9FF"];
    // this.tooltip = {
    //   trigger: "item",
    //   formatter(v) {
    //     console.log(v)
    //     if (v.data.value == undefined) {
    //       return "";
    //     } else {
    //       let str = `${v.name} <br/>${v.marker} ${v.seriesName} : ${v.data.value}`;
    //       return str;
    //     }
    //   }
    // };
    return {
      formRules: {
        maxValue: [
          { required: true, message: "请输入最大扫码次数", trigger: "blur" },
        ],
        city: [{ required: true, message: "请选择预警城市", trigger: "blur" }],
        gtin: [{ required: true, message: "请选择预警商品", trigger: "blur" }],
        batchNumber: [
          { required: true, message: "请选择预警商品批次", trigger: "blur" },
        ],
        toUserIds: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个通知对象",
            trigger: "change",
          },
        ],
      },
      editId: null,
      goodsName: "",
      batchNumber: "",
      goodsLoading: false,
      goodsOptions: [],
      batchOptions: [],
      scanCodeRecordForm: {
        maxValue: "",
        gtin: null,
        batchNumber: "",
        city: null,
        toUserIds: [],
        companyId: null,
      },
      cityProps: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level == 0) {
            axios.get("/pc/region/all", { region_type: 1 }).then((response) => {
              if (response.code === 200) {
                this.cityList = response.data.region_list.map((v) => {
                  return {
                    label: v.region_name,
                    value: v.region_code,
                  };
                });
                resolve(
                  response.data.region_list.map((v) => {
                    return {
                      label: v.region_name,
                      value: v.region_code,
                      leaf: ["重庆市", "北京市", "上海市", "天津市"].includes(
                        v.region_name
                      ),
                    };
                  })
                );
              }
            });
          } else {
            axios
              .get("/pc/region/all", {
                region_type: 2,
                region_high_code: node.value,
              })
              .then((response) => {
                if (response.code === 200) {
                  this.cityList = response.data.region_list.map((v) => {
                    return {
                      label: v.region_name,
                      value: v.region_code,
                    };
                  });
                  resolve(
                    response.data.region_list.map((v) => {
                      return {
                        label: v.region_name,
                        value: v.region_code,
                        leaf: true,
                      };
                    })
                  );
                }
              });
            // api
            //   .get("/v1/pc/scanCodeRecord/chart1", { province: node.label })
            //   .then((response) => {
            //     console.log(response);
            //     if (response.code === 200) {
            //       console.log("response.data.result", response.data);

            //       resolve(
            //         response.data.result.map((v) => {
            //           return {
            //             label: v.region,
            //             value: v.region,
            //             leaf: true,
            //           };
            //         })
            //       );
            //     }
            //   });
          }
        },
      },
      showPopover: false,
      popupVisible: false,
      companyId: null,
      cityName: "",
      provinceName: "",
      provincesData: {},
      transformation,
      chartData: {
        columns: ["位置", "扫码次数"],
        rows: [],
      },
      barChartData: {
        columns: ["位置", "扫码次数"],
        rows: [],
      },
      query: {
        gtin: "",
        batchNumber: "",
        startTime: "",
        endTime: "",
        province: "",
      },
      mapBg,
      timeRange: "",
      provinceFlag: false,
      countTime: "",
      chartSettings: {
        position: "china",
        selectedMode: "single",
        labelMap: {
          total: "扫码次数",
        },
        label: {
          normal: {
            show: true,
            textStyle: {
              color: "#fff",
              fontSize: 13,
            },
          },
          emphasis: {
            show: true,
            textStyle: {
              color: "#fff",
              fontSize: 13,
            },
          },
        },
        itemStyle: {
          normal: {
            areaColor: "transparent",
            borderColor: "rgba(147, 235, 248, 1)",
            borderWidth: 1,
            shadowColor: "rgba(128, 217, 248, 1)",
            shadowOffsetX: -2,
            shadowOffsetY: 2,
            shadowBlur: 10,
          },
          emphasis: {
            areaColor: "#04B9FF",
            shadowBlur: 10,
            shadowColor: "#fff",
          },
        },
      },
      goodsTotal: 0,
      goodsList: [],
      batchPage: {
        pager_offset: "0",
        pager_openset: "30",
        goods_id: "",
        company_id: "",
        gtin: "",
        batch_number: "",
      },
      batchLoading: false,
      batchTotal: 0,
      batchList: [],
      cityList: [],
      userList: [],
      listQuery: {
        page: 1,
        limit: 10,
      },
      list: [],
      total: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleEdit(row) {
      this.scanCodeRecordForm = {
        ...row,
      };
      this.goodsName = row.goodsName;
      this.batchNumber = row.batchNumber;
      this.scanCodeRecordForm.toUserIds = this.scanCodeRecordForm.toUserIds.map(
        (v) => Number(v)
      );
      this.cityName = row.city;

      this.editId = row.id;
    },
    handleUpdate() {
      // /v1/pc/scanCodeRecord/update
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          api
            .post("/v1/pc/scanCodeRecord/update", this.scanCodeRecordForm)
            .then((res) => {
              if (res.code == 200) {
                this.$message.success("修改成功");
                if (this.listQuery.page !== 1 && this.list.length == 1) {
                  this.listQuery.page--;
                }
                this.editId = null;
                this.hiddenPopover();
                this.getList();
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleDelete(row) {
      api.post("/v1/pc/scanCodeRecord/delete", { id: row.id }).then((res) => {
        if (res.code == 200) {
          this.$message.success("删除成功");
          if (this.listQuery.page !== 1 && this.list.length == 1) {
            this.listQuery.page--;
          }
          this.editId = null;
          this.getList();
        }
      });
    },
    handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    getList() {
      api
        .get("/v1/pc/scanCodeRecord/list", {
          ...this.listQuery,
          companyId: this.companyId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.list = res.data.map((v) => {
              return {
                ...v,
                showPopover: false,
              };
            });
            this.total = res.total;
          }
        });
    },
    scanCodeSubmit() {
      // console.log(this.scanCodeRecordForm);
      this.$refs["addform"].validate((valid) => {
        if (valid) {
          api
            .post("/v1/pc/scanCodeRecord/save", {
              ...this.scanCodeRecordForm,
              companyId: this.companyId,
            })
            .then((res) => {
              if (res.code === 200) {
                this.showPopover = false;
                this.$message.success("预警设置成功");
                this.getList();
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCheckedChange(val) {
      this.scanCodeRecordForm.toUserIds = val;
    },
    getUserList() {
      api
        .get("/v1/wx/member/pcList", {
          companyId: this.companyId,
          page: 1,
          limit: 100,
          keyword: "",
        })
        .then((res) => {
          this.userList = res.data.map((v) => {
            return {
              ...v,
              checked: false,
            };
          });
        });
    },
    goodsChange(data) {
      this.scanCodeRecordForm.gtin = data;
    },
    batchChange(data) {
      this.scanCodeRecordForm.batchNumber = data;
      // console.log(data);
      // this.scanCodeRecordForm.gtin = data;
      // this.scanCodeRecordForm.batchNumber = data.value;
    },
    remoteMethod1(query) {
      if (query !== "") {
        this.goodsLoading = true;
        this.batchPage.batch_number = query;
        api
          .get("/v1/wx/goods/batch/pcList", {
            gtin: this.scanCodeRecordForm.gtin,
            companyId: this.companyId,
            bathNumber: query,
          })
          .then((res) => {
            // console.log(res.data);
            this.batchOptions = res.data.map((v) => {
              return {
                label: v.batchNumber,
                value: v.batchNumber,
              };
            });
            this.batchTotal = res.data.total;
            this.goodsLoading = false;
          });
      } else {
        this.batchOptions = [];
        this.goodsLoading = false;
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.goodsLoading = true;
        api
          .get("/v1/pc/stock/goodsList", {
            page: 1,
            limit: 20,
            keyword: query,
            companyId: this.companyId,
          })
          .then((v) => {
            this.goodsTotal = v.data.pager_count;
            this.goodsLoading = false;
            this.goodsOptions = v.data.map((v) => {
              return {
                label: v.name,
                value: v.gtin,
                gtin: v.gtin,
              };
            });
            console.log(this.goodsOptions);

            this.goodsLoading = false;
          });
        // setTimeout(() => {
        //   this.goodsLoading = false;
        //   this.goodsOptions = this.list.filter((item) => {
        //     return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        //   });
        // }, 200);
      } else {
        this.goodsOptions = [];
        this.goodsLoading = false;
      }
    },
    cityChange(value) {
      console.log(value, "测试1");
      if (value.length == 2) {
        this.$set(
          this.scanCodeRecordForm,
          "city",
          this.cityList.filter((v) => v.value == value[1])[0].label
        );
      } else {
        console.log(this.cityList.filter((v) => v.value == value[0])[0].label);

        this.$set(
          this.scanCodeRecordForm,
          "city",
          this.cityList.filter((v) => v.value == value[0])[0].label
        );
      }
    },
    hiddenPopover() {
      this.showPopover = false;
      this.userList.forEach((v) => {
        v.checked = false;
      });
      this.scanCodeRecordForm = {
        maxValue: "",
        gtin: null,
        batchNumber: "",
        city: null,
        toUserIds: [],
        companyId: null,
      };
      this.goodsName = "";
      this.batchNumber = "";
    },
    openPopover() {},
    getBatchList() {
      this.batchLoading = true;
      axios.get("/pc/stock/batch_stock", this.batchPage).then((res) => {
        this.batchList = res.data.batch_list;
        this.batchLoading = false;
        this.batchTotal = res.data.pager_count;
        console.log("this.batchList", this.batchList);
      });
    },
    getData(val) {
      if (val === 2) {
        this.query.province = this.provinceName;
      } else {
        this.query.province = "";
      }
      let data = {
        ...this.query,
        type: 0,
      };
      if (this.companyId) {
        data.companyId = this.companyId;
      }
      api.get("/v1/pc/scanCodeRecord/chart1", data).then((response) => {
        this.chartData.columns = ["region", "total"];
        if (val === 1) {
          this.chartData.rows = response.data.result.map((m) => {
            return {
              region:
                transformation[
                  transformation.findIndex((f) => f.name2 === m.region)
                ].name1,
              total: m.total,
            };
          });
          if (data.gtin) {
            api
              .get("/v1/pc/scanCodeRecord/chart1", { ...data, type: 1 })
              .then((res) => {
                this.barChartData.rows = res.data.result;
              });
          } else {
            this.barChartData.rows = response.data.result;
          }
        } else {
          let res = response.data.result;
          // res.forEach(r => {
          //   r.city += "市"
          // });
          this.chartData.columns = ["region", "total"];
          this.chartData.rows = res;
          this.barChartData.rows = response.data.result;
        }
        this.barChartData.columns = ["region", "total"];
        // case 2:
        //   let res = response.data.result;
        //   // res.forEach(r => {
        //   //   r.city += "市"
        //   // });
        //   this.chartData.columns = ["city", "total"];
        //   this.chartData.rows = res;
        //   break;

        if (response.data.max) {
          this.chartVisualMap.max = response.data.max;
        } else {
          this.chartVisualMap.max = 1;
        }
        this.countTime = formatTime(new Date(), "yyyy-MM-dd HH:mm:ss");
      });
    },

    // areaClick(data) {
    //   if (data in this.provincesData) {
    //     this.$nextTick(_ => {
    //       this.chartSettings.position = "province/" + this.provincesData[data];
    //       this.chartData = {
    //         columns: ["位置", "people"],
    //         rows: [{ 位置: "海淀区", people: 4123 }]
    //       };
    //     });
    //   }
    // }
    getDataCity(provinceName) {
      let province =
        transformation[
          transformation.findIndex((f) => f.name1 === provinceName)
        ].name2;
      this.provinceName = province;
      let data = { province: province };
      if (this.query.batchNumber) {
        data.batchNumber = this.query.batchNumber;
      }
      if (this.query.gtin) {
        data.gtin = this.query.gtin;
      }
      if (this.query.startTime) {
        data.startTime = this.query.startTime;
      }
      if (this.query.endTime) {
        data.endTime = this.query.endTime;
      }
      if (this.companyId) {
        data.companyId = this.companyId;
      }
      api.get("/v1/pc/scanCodeRecord/chart1", data).then((response) => {
        // this.chartData.columns = ["region", "total"];
        // this.chartData.rows = response.data.result.map(m =>{
        //   return {
        //     region: transformation[transformation.findIndex(f => f.name2 === m.region)].name1,
        //     total: m.total
        //   }
        // });
        // this.barChartData.columns = ["region", "total"];
        // this.barChartData.rows = response.data.result;
        // case 2:
        let res = response.data.result;
        // res.forEach(r => {
        //   r.city += "市"
        // });
        this.chartData.columns = ["region", "total"];
        this.chartData.rows = res;
        //   break;

        if (response.data.max) {
          this.chartVisualMap.max = response.data.max;
        } else {
          this.chartVisualMap.max = 1;
        }
        this.countTime = formatTime(new Date(), "yyyy-MM-dd HH:mm:ss");
      });
    },
    reset() {
      this.chartSettings.position = "china";
      this.getData(1);
      this.provinceFlag = false;
    },
    reset1() {
      this.query = {
        gtin: "",
        batchNumber: "",
        startTime: "",
        endTime: "",
        province: "",
      };
      this.timeRange = "";
      this.chartSettings.position = "china";
      this.getData(1);
      this.provinceFlag = false;
    },
    submit() {
      if (this.timeRange) {
        this.query.startTime = this.timeRange[0];
        this.query.endTime = this.timeRange[1];
      }
      this.getData(!this.provinceFlag ? 1 : 2);
    },
  },
  created() {},
  mounted() {
    this.provincesData = provinces;
    if (localStorage.getItem("company_id")) {
      this.companyId = Number(localStorage.getItem("company_id"));
    }
    this.getData(1);
    this.getUserList();
    // axios
    //   .get("/pc/company-user-iot/getHasIotUser", {
    //     company_id: this.companyId,
    //   })
    //   .then((res) => {
    //     if (res.code == 200) {
    //       this.userList = res.data;
    //       this.checkedUser = res.data
    //         .filter((m) => m.tag)
    //         .map((m) => m.user_id);
    //       this.manageVisible = true;
    //     }
    //   });
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin: 0 !important;
}
.code-bg {
  transform-origin: 0px 0px 0px;
  background-image: url("../../../assets/image/mapbg.png");
  background-size: cover;
  background-position: 50% 0;
  background-color: rgb(0, 0, 0);
  min-width: auto;
  width: 100%;
  min-height: auto;
  height: 100%;
  overflow: hidden;
  overflow-x: hidden;
}
/deep/.daily-box {
  height: 80vh;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .el-dialog__header {
    width: 100%;
  }
  .el-tabs__content {
    height: 100%;
  }
  .el-tab-pane {
    height: 100%;
  }
  .el-dialog__body {
    flex: 1;
    height: 0;
    width: 100%;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    background-color: #eee !important;
    padding: 20px !important;
  }
}
.df {
  display: flex;
}
.aic {
  align-items: center;
}
.jcc {
  justify-content: center;
}

/deep/.el-form-item__content {
  width: calc(100% - 120px) !important;
  box-sizing: border-box;
}
/deep/.el-checkbox {
  margin: 0 !important;
  padding: 3px 0;
}
.user-scroll-box {
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
  padding-right: 20px;
}
.user-scroll {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2px;
  width: 100%;
}

.user-scroll-box1 {
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
  padding-right: 20px;
}
.user-scroll1 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2px;
  width: 100%;
}
</style>
